import type {
  MsRecommendationProcessedResponse,
  MsRecommendationResponse,
  ProcessedRecommendationItem,
  RecommendationItem,
} from '@/domains/productDiscovery/Recommendation/interfaces/msRecommendation';

export const processRecommendationResult = (
  result: MsRecommendationResponse = [],
): MsRecommendationProcessedResponse =>
  result.map((item: RecommendationItem): ProcessedRecommendationItem => {
    const config: ProcessedRecommendationItem = {
      displayAddToCartButton: item.display_add_to_cart_button,
      displayType: item.display_type,
      name: item.name,
      engineName: item.engine_name,
      originalName: item.original_name,
    };
    if (item.category_ids) config.categoryIds = item.category_ids;
    if (item.product_ids) config.productIds = item.product_ids;
    if (item.model_ids) config.modelIds = item.model_ids;
    return config;
  });
